import React, { useState } from "react";
import { RxCaretDown } from "react-icons/rx";
import { useHandleClickOutside } from "../../shared/hook/useHandleClickOutside";

const CheckboxInputDropdown = ({
  label,
  value,
  placeholder,
  list = [],
  name,
  updateForm,
  inputBg = "transparent",
}) => {
  const { isOpen, setIsOpen, ref } = useHandleClickOutside();

  const handleUpdateForm = (name, itemValue) => {
    if (value.includes(itemValue)) {
      if (value.includes(",")) {
        const filterValue = value
          .split(",")
          .map((c) => c.trim())
          .filter((c) => c !== itemValue)
          .join(",");

        //
        updateForm(name, filterValue);
      } else {
        updateForm(name, "");
      }
      return;
    }

    if (value?.length > 0) {
      const combineValue = `${value},${itemValue}`;
      updateForm(name, combineValue);
    } else {
      updateForm(name, itemValue);
    }
  };

  return (
    <div
      ref={ref}
      className="relative flex flex-col gap-2 font-unilever-shilling-normal text-[12px]"
    >
      <label className="my-0 font-unilever-shilling-normal text-[13px]">
        {label}*
      </label>
      <div
        style={{ backgroundColor: inputBg }}
        onClick={() => setIsOpen(true)}
        className="flex items-center justify-between !border !border-[#C8D3DE] p-2 cursor-pointer"
      >
        <span className="capitalize">
          {value.substring(0, 36) || placeholder}
        </span>
        <RxCaretDown
          className={`w-5 h-5 transition-all ${isOpen ? "rotate-180" : ""}`}
        />
      </div>
      {isOpen && (
        <div className="absolute z-[999999] top-[70px] left-0 bg-[#f7f8fc] max-h-[200px] overflow-y-auto w-full">
          {list.map((item, idx) => (
            <div
              key={idx}
              onClick={() => {
                handleUpdateForm(name, item);
              }}
              className="px-2 py-3 transition-all hover:bg-[#f0f2f9] cursor-pointer flex items-center gap-1"
            >
              <input
                type="checkbox"
                name={name}
                checked={value?.includes(item)}
              />
              <label className="my-0 font-unilever-shilling-normal text-[12px]">
                {item}
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CheckboxInputDropdown;
